/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ListReservationsServiceAccountResponse {
    getFixupPrototypeFunction() { return ListReservationsServiceAccountResponse.fixupPrototype; }

    static newInstance(model: Partial<ListReservationsServiceAccountResponse>): ListReservationsServiceAccountResponse {
        let obj = Object.assign(new ListReservationsServiceAccountResponse(), model);
        ListReservationsServiceAccountResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ListReservationsServiceAccountResponse>): ListReservationsServiceAccountResponse {
        if (!model) return null;
        return ListReservationsServiceAccountResponse.newInstance(<ListReservationsServiceAccountResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ListReservationsServiceAccountResponse) {
        if (!obj) return;

        models.ListReservationsServiceAccountResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ListReservationsServiceAccountResponse): boolean {
        Object.setPrototypeOf(obj, ListReservationsServiceAccountResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.cloud_account_details) {
            models.CloudAccountDetailsExtended.fixupPrototype(this.cloud_account_details);
        }
        if (this.overview_details) {
            models.OverviewDetails.fixupPrototype(this.overview_details);
        }
        if (this.usage_details) {
            models.UsageDetails.fixupPrototype(this.usage_details);
        }
        if (this.utilization) {
            for (let val of this.utilization) {
                models.UtilizationDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * Cloud Account Details
     */
    cloud_account_details: models.CloudAccountDetailsExtended;

    /**
     * Utilization
     */
    utilization: Array<models.UtilizationDetails>;

    /**
     * Overview
     */
    overview_details: models.OverviewDetails;

    /**
     * Usage details
     */
    usage_details: models.UsageDetails;

}
